module.exports = __webpack_public_path__ + "img/horizontal_2_1_r_1.4a1b12f6.png";